import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
  currentPage: 1,
  lastPage: 1,
  perPage: 25,
  properties: {},
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('car_accident', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const accidents = {
        ...data.data.accidents,
        data: enumerateArray(
          data.data.accidents.data,
          data.data.accidents.current_page,
          data.data.accidents.per_page,
        ),
      };

      commit('setListData', accidents);

      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchItem(_, id) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(`car_accident/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return data.data;
    } catch (error) {
      return error;
    }
  },

  async fetchProperties({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('car_accident/properties', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const properties = Object.entries(data.data.properties).reduce(
        (obj, [prop, values]) => {
          const result = { ...obj };

          if (Array.isArray(values)) {
            result[prop] = values.map((name, id) => ({ name, id: Number(id) }));
          } else {
            result[prop] = Object.entries(values).map(([id, name]) => ({
              name,
              id: Number(id),
            }));
          }

          return result;
        },
        {},
      );

      commit('setProperties', properties);

      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post('car_accident', params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error };
    }
  },

  async updateItem(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`car_accident/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error };
    }
  },
};

const mutations = {
  setListData(state, payload) {
    state.list = payload.data;
    state.currentPage = payload.current_page;
    state.lastPage = payload.last_page;
    state.perPage = payload.per_page;
  },

  setList(state, payload) {
    state.list = payload;
  },

  setProperties(state, payload) {
    state.properties = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
